import * as React from 'react';
import ReactLoading from 'react-loading';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Alert } from '@mui/material';
import { forgotPassword } from '../middleware/auth0.service';

export default function ForgotPassword() {
  const location = useLocation();
  const [loading, setLoading] = React.useState(false);
  const [showError, setError] = React.useState({
    error: false,
    value: '',
  });
  const [success, setSuccess] = React.useState({
    success: false,
    value: '',
  });
  const [user, setUser] = React.useState({
    email: '',
    password: '',
  });

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError({ ...showError, error: false });
    setSuccess({ ...success, success: false });
    setLoading(true);

    const data = new FormData(event.currentTarget);
    const response = forgotPassword(data.get('email'));
    response
      .then(function (response) {
        setSuccess({ success: true, value: response.data });
        setLoading(false);
      })
      .catch(function (error) {
        console.error(error);
        setError({ ...showError, error: true, value: error.description });
        setLoading(false);
      });
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{ mt: 5, bgcolor: '#fafafa', p: 4 }}
    >
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: '#2b2b33' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Fogort Password
        </Typography>
        {showError.error && <Alert severity="error">{showError.value}</Alert>}
        {success.success && <Alert severity="success">{success.value}</Alert>}
        {location.state !== null && (
          <Alert severity="success">{location.state}</Alert>
        )}
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email"
                label="Email Your Address"
                name="email"
                autoComplete="email"
                onChange={onChangeHandler}
                error={showError.error}
                helperText={showError.error ? showError.value : undefined}
                inputProps={{
                  style: { borderBottom: '10px solide: #000' },
                }}
              />
            </Grid>
          </Grid>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: '2em',
              bgcolor: '#2b2b33',
              color: '#fff',
              p: 1.5,
              width: '100%',
            }}
          >
            {!loading ? (
              'Verify Email'
            ) : (
              <ReactLoading
                type={'spin'}
                color={'#fff'}
                height={30}
                width={30}
              />
            )}
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid sx={{ mt: 1 }}>
              <Link
                component={RouterLink}
                to={'/get-started'}
                variant="body2"
                style={{
                  color: '#000',
                  fontWeight: 'bold',
                  fontSize: 15,
                  textAlign: 'center',
                }}
              >
                Don't have an account yet? Sign up
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}
